import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { IntegrationStatus } from '../../reducers/airbnb'
import makeIntegration from '../../models/Integration/makeIntegration'
import {
  getAirbnbChecked,
  getAirbnbSync,
} from '../../reducers/airbnb/selectors'
import { toggleAirbnbSync } from '../../actions/airbnb'

function* createIntegration(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateAirbnbIntegration)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, makeIntegration)),
    ])

    const checked = yield Effects.select(getAirbnbChecked)
    const status = yield Effects.select(getAirbnbChecked)
    const sync = yield Effects.select(getAirbnbSync)

    if (sync === 1) {
      return ''
    }

    if (!checked || status === IntegrationStatus.Integrated) {
      return ''
    }

    yield call(service, action.code)

    yield Effects.delay(500)

    yield Effects.put(toggleAirbnbSync(1))

    yield Effects.delay(500)

    yield Effects.put({ type: IntegrationAction.GET_STATUS })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.throttle(
    60000,
    IntegrationAction.CreateIntegration,
    createIntegration,
  )
}
